import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import tenantReducer from "./slices/tenantSlice";
import cartReducer from "./slices/cartSlice";
import categoryReducer from "../store/slices/categorySlice";
import userLocationReducer from "../store/slices/userLocationSlice";
import checkoutReducer from "../store/slices/checkoutSlice";

/**
 * Root reducer combining all feature slices
 */
export const rootReducer = combineReducers({
  auth: authReducer,
  tenant: tenantReducer,
  cart: cartReducer,
  category: categoryReducer,
  userLocation: userLocationReducer,
  checkout: checkoutReducer,
});
